import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from 'environments/environment';

@NgModule()
export class IconsModule {

    constructor(
        private _domSanitizer: DomSanitizer,
        private _matIconRegistry: MatIconRegistry
    ) {

        let assetsUrl = 'assets/icons/';

        if (environment.production) {
            const script = document.currentScript as HTMLScriptElement;

            if (script?.src) {
                const scriptSrc = script.src.split('widget/');

                if (scriptSrc.length > 1) {
                    assetsUrl =
                        scriptSrc[0]
                            .replace('chat-app', 'app')
                            .replace('widget', '') +
                        'assets/icons/';
                }
            }
        }

        // Material Twotone
        // this._matIconRegistry.addSvgIconSet(
        //     this._domSanitizer.bypassSecurityTrustResourceUrl(
        //         `${assetsUrl}material-twotone.svg`
        //     )
        // );

        // Material Twotone - ícone utilizado pelo chat
        this._matIconRegistry.addSvgIconLiteral(
            'close',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                </svg>
            `)
        );

        // Material Outline - anexar arquivo
        this._matIconRegistry.addSvgIconLiteral(
            'attach_file',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24">
                    <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"></path>
                </svg>
            `)
        );

        // Material Outline - ícones utilizados pelo chat
        this._matIconRegistry.addSvgIconLiteral(
            'keyboard_arrow_down',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'error',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'lock',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6-5c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3zm6 17H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'open_in_new',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'emoji_emotions',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'send',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'description',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-3-9H8v2h7v-2zm0 4H8v2h7v-2z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'add',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'arrow_back_ios',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M17.77 20.23 16.23 21.77 6.46 12 16.23 2.23 17.77 3.77 9.54 12z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'arrow_forward_ios',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M6.23 20.23 7.77 21.77 17.54 12 7.77 2.23 6.23 3.77 14.46 12z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'file_download',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zm-8-4h2v6h1.17L12 13.17 9.83 11H11V5zM5 18v2h14v-2H5z"></path>
                </svg>
            `)
        );

        this._matIconRegistry.addSvgIconLiteral(
            'mail',
            this._domSanitizer.bypassSecurityTrustHtml(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5l-8-5V6l8 5l8-5v2z"></path>
                </svg>
            `)
        );

        // Material Outline
        this._matIconRegistry.addSvgIconSetInNamespace(
            'mat_outline',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${assetsUrl}material-outline.svg`
            )
        );

        // Material Solid
        this._matIconRegistry.addSvgIconSetInNamespace(
            'mat_solid',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${assetsUrl}material-solid.svg`
            )
        );

        // Feather
        this._matIconRegistry.addSvgIconSetInNamespace(
            'feather',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${assetsUrl}feather.svg`
            )
        );

        // Heroicons Outline
        this._matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_outline',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${assetsUrl}heroicons-outline.svg`
            )
        );

        // Heroicons Solid
        this._matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_solid',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${assetsUrl}heroicons-solid.svg`
            )
        );

    }

}